import { AfterViewInit, Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { Router } from '@angular/router';
import { Utils } from '@app/_core/helper/Utils';
import { ManagerService } from '@app/_core/services/manager.service';

@Component({
  selector: 'app-review-voicemail',
  standalone: false,
  templateUrl: './review-voicemail.component.html',
  styleUrl: './review-voicemail.component.scss'
})
export class ReviewVoicemailComponent implements OnInit, AfterViewInit {
  @ViewChild('audioPlayer') audioPlayer: ElementRef;
  audioObject: any;
  filePath: any;

  constructor(private router: Router, private managerService: ManagerService){}

  ngOnInit(): void {
    //debugger;
    this.filePath = decodeURIComponent(this.router.url.split('?').pop().split("=").pop());
    console.log("File Path: ", this.filePath);
  }

  ngAfterViewInit() {
    this.managerService.getRecordingFiles(this.filePath).subscribe(response => {
      this.audioObject = response;
      const binaryData = 'data:' + response.MimeType + ';base64,' + response.result;
      const binary = Utils.convertDataURIToBinary(binaryData);
      const blob = new Blob([binary], { type: response.MimeType });
      const blobUrl = URL.createObjectURL(blob);
      this.audioPlayer.nativeElement.src = blobUrl;
      //Autoplay
      //this.audioPlayer.nativeElement.play();
    });
   }

   shortenString(str) {
    if (str.length > 80) {
      const firstPart = str.slice(0, 40);
      const lastPart = str.slice(-40);
      return `${firstPart}...${lastPart}`;
    }
    return str;
  }
  
}
